'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('e-form-opt-in', {
      url: '/e-form-opt-in',
      template: '<e-form-opt-in></e-form-opt-in>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/e-form/opt-in/e-form-opt-in.routes.js